export const readStoredFlag = (key, field, defaultValue = false) => {
  const raw = window.localStorage.getItem(key)
  if (!raw) return defaultValue

  try {
    const parsed = JSON.parse(raw)
    if (Object.prototype.hasOwnProperty.call(parsed, field)) {
      return parsed[field]
    }
  } catch {
    // Legacy JWT-signed values from older builds; drop and fall back.
    window.localStorage.removeItem(key)
  }

  return defaultValue
}

export const writeStoredFlag = (key, payload) => {
  window.localStorage.setItem(key, JSON.stringify(payload))
}
